import PropTypes from 'prop-types'

const ReportHeader = ({ title }) => {
    return (
        <header className='header'>
            <h1>{title}</h1>
        </header>
    )
}

ReportHeader.defaultProps = {
    title: 'User Details',
}

ReportHeader.propTypes = {
    title: PropTypes.string.isRequired,
}

export default ReportHeader
